export interface AppointmentTypeLocation {
  id?: string;
  facilityName?: string;
  friendlyLocationName?: string;
  locationPhoneNumber?: string;
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface LocationDetails {
  searchLocationId?: string;
  searchLocationName?: string;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestLocationList = new Array(3)
  .fill(undefined)
  .map((item, index) => ({
    id: `location${index}`,
    facilityName: `Facility Name ${index}`,
    friendlyLocationName: `Friendly Name ${index}`,
    locationPhoneNumber: '555-555-5555',
    streetAddress1: '123 Fourth Street',
    streetAddress2: 'Suite 56',
    city: 'Marshfield',
    state: 'WI',
    zip: '54449',
  }));

export const DefaultTestLocationDetails = {
  searchLocationId: '',
  searchLocationName: '',
};
